module.exports = __webpack_public_path__ + "static/media/298470.452ebcd3.png";